"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zan = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Turmoil_1 = require("../../turmoil/Turmoil");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
class Zan extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.ZAN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L26',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.text('IMMUNE TO').reds();
                    b.br.br;
                    b.opgArrow().text('ALL', Size_1.Size.SMALL).delegates(1).colon().reds().megacredits(1);
                }),
                description: 'You are immune to Reds\' ruling policy. Once per game, place ALL your delegates in Reds. Gain 1 M€ for each delegate placed this way.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        const reserveDelegates = turmoil.delegateReserve.filter((d) => d === player.id).length;
        const totalMegacreditsGained = turmoil.lobby.has(player.id) ? reserveDelegates + 1 : reserveDelegates;
        for (let i = 0; i < reserveDelegates; i++) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.REDS, game, 'reserve');
                player.totalDelegatesPlaced++;
                return undefined;
            }));
        }
        if (turmoil.lobby.has(player.id)) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.REDS, game, 'lobby');
                player.totalDelegatesPlaced++;
                return undefined;
            }));
        }
        player.addResource(Resources_1.Resources.MEGACREDITS, totalMegacreditsGained, { log: true });
        this.isDisabled = true;
        return undefined;
    }
}
exports.Zan = Zan;
//# sourceMappingURL=Zan.js.map